import { Svg, type Props as SvgProps } from './Svg'

export const IconAbn = (props: SvgProps) => (
	<Svg {...props} viewBox='0 0 24 24' fill='currentcolor' xmlns='http://www.w3.org/2000/svg'>
		<path d='M19 3.5V15L12 8V22L5 15V3.5H19Z' />
	</Svg>
)
